var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ7A(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1549 55C20.1567 63.9768 34.5767 60.7668 20.1567 63.9768C78.7467 67.5868 139.075 71.85 197.665 75.46L228.635 61.22L65.1549 55Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 185.471V63.8806C78.77 65.9906 139.758 68.8438 198.528 70.9638C199.488 113.254 198.24 154.801 199.2 197.081L20 185.471Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.255 133.07C129.185 159.7 107.305 179.71 82.3848 177.77C57.4648 175.83 38.9547 152.67 41.0247 126.05C43.0947 99.4201 64.9747 79.4102 89.8947 81.3502C114.815 83.2902 133.325 106.45 131.255 133.07Z",
    fill: "#FECECA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.545 61.3301L198.225 70.97C199.185 113.26 198.193 154.81 199.153 197.09L229.498 177.6C229.308 139.77 228.735 99.1601 228.545 61.3301Z",
    fill: "#29A063"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.375 136.69C110.705 126.13 98.4445 127.05 92.0145 128.33C91.2545 125.87 89.1746 124.32 86.8646 123.56C87.3946 117.24 94.8446 115.81 98.3346 106.16C102.595 94.32 82.6346 86.7101 73.7346 101.01C67.4146 111.04 74.1246 121.36 78.5046 126.24C77.6046 127.54 76.8446 129.2 76.8446 131.01C76.8446 131.91 76.9846 132.82 77.3746 133.72C72.0746 137.2 66.2946 131.93 56.3746 134.89C44.5046 138.36 50.3145 158.98 66.9345 157.69C78.9245 156.79 83.0446 145.32 84.4446 138.89H84.8346C87.0046 138.89 88.9546 137.99 90.3646 136.69C95.6646 140.17 93.3245 147.63 99.8945 155.5C108.015 165.06 124.365 151.41 116.385 136.69H116.375ZM84.2945 134.64C82.3145 134.64 80.6946 133.03 80.6946 131.04C80.6946 129.05 82.3045 127.44 84.2945 127.44C86.2845 127.44 87.8945 129.04 87.8945 131.04C87.8945 133.04 86.2845 134.64 84.2945 134.64Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.445 112.05C142.575 109.39 144.845 107.34 147.505 107.47L184.595 109.31C187.255 109.44 189.305 111.7 189.175 114.36C189.045 117.03 186.775 119.08 184.115 118.94L147.035 117.11C144.375 116.98 142.325 114.71 142.455 112.05H142.445Z",
    fill: "#29A063"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.385 131.03C142.515 128.36 144.785 126.31 147.445 126.45L184.525 128.28C187.185 128.41 189.235 130.68 189.105 133.34C188.975 136 186.705 138.05 184.045 137.92L146.965 136.08C144.305 135.95 142.255 133.69 142.385 131.03Z",
    fill: "#29A063"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.385 148.48C142.515 145.82 144.785 143.76 147.445 143.9L184.525 145.73C187.185 145.86 189.235 148.13 189.105 150.79C188.975 153.45 186.705 155.5 184.045 155.37L146.965 153.53C144.305 153.4 142.255 151.14 142.385 148.48Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ7A);
export default __webpack_public_path__ + "static/media/q7a.38dd8a2d67bdcd711ff415515c171dfb.svg";
export { ForwardRef as ReactComponent };